import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'alert',
  styleUrls: ['./alert.component.scss'],
  templateUrl: './alert.component.html',
})
export class AlertComponent {
  alertMessage: string;
  alertType: string;

  constructor(public snackBarRef: MatSnackBarRef<AlertComponent>, @Inject(MAT_SNACK_BAR_DATA) public alertData: any) {
    this.alertMessage = this.alertData.message;
    this.alertType = this.alertData.type;
  }

  dismiss(): void {
    this.snackBarRef.dismiss();
  }
}
